import { page } from '$app/state';
import {
	getSearchExtensionBaseUrl,
	searchExtensionContext,
	type SearchExtensionContextContent,
	type SearchExtensionTouchpoint,
} from '$lib/services/searchExtension';
import { getDomain, getLabel, type StatDomain } from '$lib/utils/getBookingUrl';
import { getLocalTimeZone, today } from '@internationalized/date';
import { isLargeDevice } from './getPlatform';

export function getBookingUrlTab(searchExtensionContextContent: SearchExtensionContextContent, touchpoint?: SearchExtensionTouchpoint) {
	const { pagename: pageName } = page.data;
	const { address, coordinates } = searchExtensionContextContent;
	const domain = getDomain();
	const aid = getBookingAid(domain);
	const label = getLabel({
		contentType: 'search_extension',
		arrival: address,
		pageName,
		triggerSE: touchpoint,
	});

	const localDate = today(getLocalTimeZone());
	const checkin = isLargeDevice() ? localDate.add({ days: 1 }) : localDate;
	const checkout = checkin.add({ days: 1 });

	const hasContext = searchExtensionContext.hasContext();
	const searchExtensionBaseURL = getSearchExtensionBaseUrl();
	const pathName = getBookingPathName(hasContext, domain);

	const bookingUrl = new URL(`${searchExtensionBaseURL}/${pathName}`);

	bookingUrl.searchParams.set('aid', aid);

	if (address) {
		bookingUrl.searchParams.set('ss', address);
	}

	if (coordinates?.lat && coordinates?.lng) {
		bookingUrl.searchParams.set('place_id_lat', coordinates.lat.toString());
		bookingUrl.searchParams.set('place_id_lon', coordinates.lng.toString());
	}
	bookingUrl.searchParams.set('checkin', checkin.toString());
	bookingUrl.searchParams.set('checkout', checkout.toString());
	bookingUrl.searchParams.set('label', label);

	return bookingUrl.toString();
}

function getBookingPathName(hasContext: boolean, domain: StatDomain) {
	if (hasContext) {
		return 'searchresults.html';
	}

	const pageName = domain === 'com' ? 'us' : domain === 'co.uk' ? 'gb' : domain;
	return `country/${pageName}.html`;
}

function getBookingAid(domain: StatDomain) {
	const bookingAid = {
		'com': '1595946',
		'at': '1595948',
		'be': '1595949',
		'ch': '1595950',
		'fr': '1595945',
		'co.uk': '1595951',
		'de': '1595952',
		'es': '1595953',
		'ie': '1595954',
		'it': '1595955',
		'nl': '1595956',
		'pl': '1595957',
		'pt': '1595958',
	};
	return bookingAid[domain] || bookingAid.fr;
}
